export default __webpack_public_path__ + "static/media/user.23007704.svg";